import { render, staticRenderFns } from "./exercise-analyze.vue?vue&type=template&id=4d32a3f8&scoped=true"
import script from "./exercise-analyze.vue?vue&type=script&lang=js"
export * from "./exercise-analyze.vue?vue&type=script&lang=js"
import style0 from "./exercise-analyze.vue?vue&type=style&index=0&id=4d32a3f8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d32a3f8",
  null
  
)

export default component.exports